/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import _regeneratorRuntime from "E:\\ysh\\wx-master\\node_modules\\_@babel_runtime@7.16.5@@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */


import { userDetail } from '@/api/ajax';
import router from '@/router/index';
import store from '@/store';
export var setStorage = function setStorage(key, val) {
  //设置缓存
  var values = val;

  if (_typeof(val) == 'object') {
    values = JSON.stringify(val);
  }

  localStorage.setItem(key, values);
};
export var getStorage = function getStorage(key) {
  //获取缓存
  if (!localStorage[key]) {
    return null;
  } else {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }
};
/**
 * @description: 获取当前专区下用户信息
 * @param { string } afferentName 传入专区缓存key，不是必须。
 *                                拦截器中，第一次调用时，router在这里没有参数
 * @return { object }
 */

export var storageUserInfo = function storageUserInfo(afferentName) {
  var channelNo = router.currentRoute.params.channelNo;
  var storageName = afferentName || 'channel' + channelNo;
  var userInfo = getStorage(storageName) || {};
  store.commit('user/SET_INFO', userInfo);
  return userInfo;
}; // 同步当前用户信息并返回

export var syncUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var channelNo, userInfo, _yield$userDetail, info, storageName;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            channelNo = router.currentRoute.params.channelNo;
            userInfo = data;

            if (userInfo) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return userDetail();

          case 5:
            _yield$userDetail = _context.sent;
            info = _yield$userDetail.data.data;
            userInfo = info;

          case 8:
            storageName = 'channel' + channelNo;
            setStorage(storageName, userInfo);
            store.commit('user/SET_INFO', userInfo);
            return _context.abrupt("return", Promise.resolve(userInfo));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function syncUserInfo(_x) {
    return _ref.apply(this, arguments);
  };
}(); // 设置跳往注册前的URL

export var setBeforeRegisterUrl = function setBeforeRegisterUrl(url) {
  url = url || window.location.href;

  if (!['sms', 'word', 'perfect', 'register'].includes(url)) {
    sessionStorage.setItem('beforeRegisterUrl', url);
  }
}; // 注册后回跳使用

export var jumpBeforeRegisterUrl = function jumpBeforeRegisterUrl() {
  var beforeRegisterUrl = sessionStorage.beforeRegisterUrl;

  if (beforeRegisterUrl) {
    sessionStorage.removeItem('beforeRegisterUrl');
    window.location.href = beforeRegisterUrl;
  }

  return beforeRegisterUrl;
};